/* =============================================================================
   PRODUCT GALLERY - CLICK TO ZOOM ON ALL DEVICES
   
   Enables click-to-zoom on mobile and tablet, not just desktop, by opening
   the stock product-gallery lightbox. Loaded from layout/theme.liquid.
   ============================================================================= */

(function() {
  'use strict';

  // Click-to-zoom on every device: open the stock lightbox from any image in the gallery carousel.
  document.addEventListener('click', function(event) {
    // Check if click is on an image inside a product gallery
    if (event.target.tagName !== 'IMG') {
      return;
    }

    const gallery = event.target.closest('product-gallery');
    if (!gallery || !gallery.hasAttribute('allow-zoom')) {
      return;
    }

    const media = event.target.closest('.product-gallery__media');
    if (!media || media.getAttribute('data-media-type') !== 'image') {
      return;
    }

    // Check if we're in the carousel (not in thumbnails)
    if (!event.target.closest('.product-gallery__carousel')) {
      return;
    }

    // Prevent any default behavior
    event.preventDefault();

    // Mark gallery as having been zoomed (hides mobile hint)
    gallery.classList.add('has-zoomed');

    // Get the carousel and find image index
    const carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    // Get all cells and filter to images only
    const allCells = Array.from(carousel.querySelectorAll('.product-gallery__media'));
    const imageCells = allCells.filter(cell => cell.getAttribute('data-media-type') === 'image');
    const clickedIndex = imageCells.indexOf(media);

    // Dispatch lightbox open event
    gallery.dispatchEvent(new CustomEvent('lightbox:open', { 
      bubbles: true, 
      detail: { index: clickedIndex >= 0 ? clickedIndex : 0 } 
    }));

  }, { capture: true }); // Use capture to intercept before other handlers


})();